import React, { useRef, useState } from "react";
import { AppearancePicker } from "components/common/AppearancePicker";
import { resolveDatasetColor } from "@/lib/datasetColor";
import { SPACE_PALETTE } from "@/components/main/stores/orgContextStore";
import { SpaceDot } from "./SpaceDot";

/// A space's swatch, opening the palette: the settings header and the create
/// dialog both pick through it.
export const SpaceColorPicker: React.FC<{
  color: string;
  onPick: (color: string) => void;
}> = ({ color, onPick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  return (
    <span
      className="relative flex shrink-0 items-center"
      // Covers the portaled palette too: a click leaves focus where it was, so
      // the name field keeps its caret through a pick.
      onMouseDown={(e) => e.preventDefault()}
    >
      <button
        ref={anchorRef}
        type="button"
        aria-label="Change space color"
        onClick={() => setIsOpen((v) => !v)}
        className="flex h-4 w-4 cursor-pointer items-center justify-center rounded-app hover:bg-list-hover"
      >
        <SpaceDot color={color} size="lg" />
      </button>
      <AppearancePicker
        currentColor={color}
        colors={SPACE_PALETTE}
        resolveColor={resolveDatasetColor}
        onColorChange={(picked) => {
          setIsOpen(false);
          onPick(picked);
        }}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        anchorRef={anchorRef}
      />
    </span>
  );
};
